import { computed, ref } from "vue";
import { Tank, TankGroup } from "@/types/v2";

export function useWeightForm() {
  // ===================================================================
  // State
  // ===================================================================
  const weightId = ref<string | null>(null);
  const selectedTank = ref<Tank | null>(null);
  const selectedGroup = ref<TankGroup | null>(null);
  const weight = ref<number>(0); // Represented in grams
  const comment = ref<string>("");

  // ===================================================================
  // Computed
  // ===================================================================
  const canSave = computed(() => weight.value > 0);

  // ===================================================================
  // Actions
  // ===================================================================
  // Reset Form State
  const resetForm = () => {
    weightId.value = null;
    weight.value = 0;
    comment.value = "";
  }

  return {
    // ===================================================================
    // State
    // ===================================================================
    weightId,
    selectedGroup,
    selectedTank,
    weight,
    comment,

    // ===================================================================
    // Validation
    // ===================================================================
    canSave,

    // ===================================================================
    // Actions
    // ===================================================================
    resetForm
  }
}